enum EditToolsEnum {
  ADD_MANY = 1,
  ADD_REMOVE_SINGLE = 2,
  CLEAR = 3,
  ADD_REMOVE_RESTRICTED = 4,
  ADD_REMOVE_SPECIAL = 5,
}

export default EditToolsEnum;
